<template>
  <BaseButton primary outline small class="w-full" @click="open">
    <span class="truncate"> Add Category </span>
  </BaseButton>
</template>

<script>
import { tagCategoriesClient } from '@/api/clients/admin';

export default {
  data() {
    return {
      showForm: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('Components/TagCategory/TagCategoryCreateModal.vue'),
        props: {
          action: tagCategoriesClient.store,
        },
        on: {
          'tag-category-created': (tagCategory) => {
            this.$emit('tag-category-created', tagCategory);
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
